import React, { FC } from 'react';
import { FormattedDate } from 'src/components/formatted-date/formatted-date';
import { TD } from '../../../components/table/table';
import { IOrderSimulation } from '../../../graphql/types';

interface IOrderSimulationTableBodyProps {
  orderSimulation: IOrderSimulation;
}

const OrderSimulationTableBody: FC<IOrderSimulationTableBodyProps> = ({
  orderSimulation,
}) => {
  return (
    <tbody>
      {orderSimulation.schedule.map(simulation => {
        return (
          <tr key={simulation.lineIndex} data-value={simulation.lineIndex}>
            <TD>{simulation.lineIndex}</TD>
            <TD>{simulation.desiredQuantity}</TD>
            <TD>{simulation.confirmedQuantity}</TD>
            <TD>{simulation.unitOfMeasure}</TD>
            <TD>
              <FormattedDate date={simulation.deliveryLeadTimeDate} />
            </TD>
            <TD>
              <FormattedDate date={simulation.actualDeliveryDate} />
            </TD>
            <TD>{simulation.backorderQuantity}</TD>
            <TD>{simulation.backordered}</TD>
          </tr>
        );
      })}
    </tbody>
  );
};

export { OrderSimulationTableBody };
